/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OpeningStatusV2 } from '../models/OpeningStatusV2';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OpeningStatusV2Service {

    /**
     * get status
     * Returns the status for a specified funnel
     * @param externalId Opening#external_id
     * @returns any success
     * @throws ApiError
     */
    public static getApiSelfServeV2OpeningsStatusV2(
        externalId: string,
    ): CancelablePromise<{
        status: OpeningStatusV2;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api_self_serve/v2/openings/{external_id}/status_v2',
            path: {
                'external_id': externalId,
            },
        });
    }

    /**
     * update status
     * Updates the status for a specified funnel
     * @param externalId Opening#external_id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiSelfServeV2OpeningsStatusV2(
        externalId: string,
        requestBody: {
            status: OpeningStatusV2;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api_self_serve/v2/openings/{external_id}/status_v2',
            path: {
                'external_id': externalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `unauthorized`,
            },
        });
    }

    /**
     * update listing status
     * Changes the status and the sourcing status of an opening on an account running the four-state sourcing model. Returns the opening as saved: an activation held for approval comes back inactive and pending. With expected_active or expected_listing_status, a change against an opening changed since answers 409 with its current values.
     * @param externalId Opening#external_id
     * @param requestBody
     * @returns any the opening as saved
     * @throws ApiError
     */
    public static patchApiSelfServeV2OpeningsListingStatus(
        externalId: string,
        requestBody: {
            status?: 'active' | 'inactive';
            listing_status?: 'public' | 'internal' | 'not_posted' | 'intake_closed';
            /**
             * The status the caller saw. A mismatch answers 409.
             */
            expected_active?: boolean;
            /**
             * The sourcing status the caller saw. A mismatch answers 409.
             */
            expected_listing_status?: 'public' | 'internal' | 'not_posted' | 'intake_closed';
        },
    ): CancelablePromise<{
        active: boolean;
        listing_status: 'public' | 'internal' | 'not_posted' | 'intake_closed';
        approval_status: 'pending' | 'approved' | 'rejected';
        is_sourcing_funnel?: boolean;
        is_internal_funnel?: boolean;
        internal_job_expiration_date?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api_self_serve/v2/openings/{external_id}/listing_status',
            path: {
                'external_id': externalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `the opening changed since the caller read it; nothing is saved`,
                422: `unprocessable entity`,
            },
        });
    }

    /**
     * get status options
     * Returns the possible statuses for a specified funnel
     * @param externalId Opening#external_id
     * @returns any success
     * @throws ApiError
     */
    public static getApiSelfServeV2OpeningsStatusOptions(
        externalId: string,
    ): CancelablePromise<Array<{
        status: OpeningStatusV2;
        /**
         * Whether or not the specified funnel has that status
         */
        selected: boolean;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api_self_serve/v2/openings/{external_id}/status_options',
            path: {
                'external_id': externalId,
            },
        });
    }

}